import { render, staticRenderFns } from "./LayOutChange.vue?vue&type=template&id=2e62ed2c&"
import script from "./LayOutChange.vue?vue&type=script&lang=js&"
export * from "./LayOutChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports